export interface Project {
  id: string;
  title: string;
  slug?: string;
  description: string;
  featured_image: string | null;
  gallery_images?: string[]; // Array of images for slideshow
  category: string;
  tech_stack: string[];
  demo_url?: string;
  features?: {
    id: string;
    name: string;
    status: 'completed' | 'in-progress' | 'not-started';
  }[];
  status: 'concept' | 'prototype' | 'mvp' | 'in_development' | 'launched' | 'scaling' | 'retired';
  
  // New entrepreneurial fields
  stage?: 'concept' | 'prototype' | 'mvp' | 'launched' | 'scaling' | 'retired';
  completion_percentage?: number;
  video_demo_url?: string;
  prototype_link?: string;
  key_features?: {
    name: string;
    description: string;
    status: 'completed' | 'in-progress' | 'planned';
  }[];
  metrics?: {
    users?: number;
    revenue?: number;
    growth_rate?: number;
    market_size?: string;
    [key: string]: any;
  };
  lessons_learned?: string;
  whats_next?: string;
  is_featured?: boolean;
  
  // SEO fields
  meta_title?: string;
  meta_description?: string;
  og_image_url?: string;
  keywords?: string[];
  
  view_count?: number;
  last_viewed?: string;
  created_at?: string;
  updated_at?: string;
}

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  readingTime: string;
  tags: string[];
  image?: string;
  slug: string;
  category: string;
  // SEO fields
  seo_title?: string;
  seo_description?: string;
  seo_keywords?: string[];
  og_image?: string;
  view_count?: number;
  last_viewed?: string;
}

export type Theme = 'light' | 'dark';

export const ARTICLE_CATEGORIES = {
  'Random Thought': '🎲',
  Crypto: '₿',
  Finance: '📈',
  Lifestyle: '🌟',
  Startup: '🚀',
  Technology: '💻',
  Journal: '📔'
} as const;

export type ArticleCategory = keyof typeof ARTICLE_CATEGORIES;